import * as React from "react";
import Drawer from "@mui/material/Drawer";
import useWarehouse from "../services/queries/useWarehouse";
import useUser from "../services/queries/useUser";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import AlertSnackbar from "../components/AlertSnackbar/AlertSnackbar";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ModalKonfirmasiLogout from "../components/ModalKonfirmasiLogout/ModalKonfirmasiLogout";
import { Backdrop, Badge, Button, CircularProgress } from "@mui/material";
import { useAlert } from "../context/alertContext";
import { ParamsGetWarehouse } from "../constants/types";
import { Link, useLocation, useHistory } from "react-router-dom";
import { getLocalWarehouseId } from "../utils/handleChangeWarehouseId";
import {
    AppBar,
    Avatar,
    Box,
    Chip,
    Container,
    IconButton,
    Link as MaterialLink,
    Stack,
    Toolbar,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useWarehouseIsDueExpired from "../services/queries/useWarehouseIsDueExpired";
import { WhatsApp } from "@mui/icons-material";
import useNoWaAdmin from "../services/queries/useNoWaAdmin";
import logoUloGif from "../assets/images/LoadingUlo.gif";
import ModalAlertPro from "../components/ModalAlertPro/ModalAlertPro";
import useTime from "../services/queries/useTime";
interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    children: React.ReactNode;
    // window?: () => Window;
}

// interface CountdownProps {
//     expiredTime: number;
// }

// const UnmemorizedCountdownComponent: React.FC<CountdownProps> = (props) => {
//     return (
//         <Countdown
//             date={Date.now() + props.expiredTime - 4000}
//             renderer={({ completed, formatted }) => {
//                 if (completed) {
//                     // Render a complete state
//                     return <span>00:00:00</span>;
//                 } else {
//                     // Render a countdown
//                     return (
//                         <Typography
//                             display="inline"
//                             sx={{
//                                 fontWeight: "bold",
//                                 color: "rgba(69, 167, 121, 1)",
//                                 // border: "1px solid rgba(69, 167, 121, 1)",
//                                 // borderRadius: "4px",
//                                 // padding: "3px 9px",
//                                 // color: "#fff",
//                                 // backgroundColor: "rgba(69, 167, 121, 1)",
//                             }}
//                         >
//                             {formatted.days} hari, {formatted.hours} jam
//                         </Typography>
//                     );
//                 }
//             }}
//         />
//     );
// };

// const CountdownComponent = React.memo(UnmemorizedCountdownComponent);

export default function PageLayout(props: Props) {
    const { children } = props;
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const { data: user, isLoading: isLoadingUser } = useUser();
    const initialParamsWarehouseIsDueExpired = React.useMemo(
        () => ({
            search: "",
            size: 5,
            page: 1,
            isDueExpired: 1,
        }),
        [],
    );
    const { data: warehouseIsDueExpired } = useWarehouseIsDueExpired(
        initialParamsWarehouseIsDueExpired,
    );
    const { isOpenAlert, handleCloseAlert, words } = useAlert();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    // const [isOpenModalTrial, setIsOpenModalTrial] = React.useState(false);
    const [isOpenModalAlertPro, setIsOpenModalAlertPro] = React.useState(false);
    // const [openSubmenu, setOpenSubmenu] = React.useState(true);
    const thisYear = new Date().getFullYear();
    const { data: noWaAdmin } = useNoWaAdmin();
    const { data: time } = useTime();

    const location = useLocation();
    let history = useHistory();

    // const openModalTrial = () => setIsOpenModalTrial(true);
    // const closeModalTrial = () => setIsOpenModalTrial(false);

    const initialParamsWarehouse = {
        size: 500,
        page: 1,
        search: "",
    };

    const [paramsWarehouse, setParamsWarehouse] =
        React.useState<ParamsGetWarehouse>(initialParamsWarehouse);
    const { data: warehouse, isLoading: isLoadingWarehouse } =
        useWarehouse(paramsWarehouse);

    const warehouseId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalWarehouseId(user?.userId);
        }
        return null;
    }, [user]);

    const drawerWidth = 190;

    const warehouseData = React.useMemo(() => {
        if (warehouseId) {
            return warehouse?.content.find((li) => li.id === warehouseId);
        }
        return warehouse?.content[0];
    }, [warehouseId, warehouse]);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    // const dateExpiredTime = React.useMemo(
    //     () => moment(warehouseData?.trialTempo),
    //     [warehouseData?.trialTempo],
    // );
    // const dateNow = React.useMemo(() => moment(), []);
    // const expiredTime = dateExpiredTime.diff(dateNow);

    React.useEffect(() => {
        if (user && user?.warehouseId?.length > 0) {
            setParamsWarehouse((prev) => ({
                ...prev,
                userId: user.warehouseId[0],
            }));
        }
    }, [user]);

    history.listen(() => {
        setMobileOpen(false);
    });

    const laptopDrawer = (
        // <div>
        <Stack flex={1} direction="column" alignItems="flex-start" marginY={2}>
            <Box width="100%">
                <Box
                    width="100%"
                    display="flex"
                    justifyContent="center"
                    marginBottom={2}
                >
                    <Link to="/pengaturan">
                        <Stack
                            direction="column"
                            spacing={1}
                            alignItems="center"
                        >
                            <Badge
                                overlap="circular"
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                badgeContent={
                                    <Box
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            position: "relative",
                                            backgroundColor: "#fff",
                                            borderRadius: "50%",
                                        }}
                                    >
                                        <Box>
                                            <OpenInNewIcon
                                                sx={{
                                                    fontSize: "0.8rem",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform:
                                                        "translate(-50%, -50%)",
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                }
                            >
                                {warehouseData?.alamatToko === "-" ||
                                // !!!warehouseData?.jenisUsaha ||
                                !!!warehouseData?.alamatToko ? (
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                        variant="dot"
                                        sx={{
                                            // display:
                                            //     warehouseData?.alamatToko === "-" ||
                                            //     !!!warehouseData?.alamatToko
                                            //         ? undefined
                                            //         : "none",
                                            "& .MuiBadge-badge": {
                                                backgroundColor: "#fa4c46",
                                                color: "#fa4c46",
                                                boxShadow: `0 0 0 2px #fff`,
                                                "&::after": {
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: "50%",
                                                    animation:
                                                        "ripple 1.2s infinite ease-in-out",
                                                    border: "1px solid currentColor",
                                                    content: '""',
                                                },
                                            },
                                            "@keyframes ripple": {
                                                "0%": {
                                                    transform: "scale(.8)",
                                                    opacity: 1,
                                                },
                                                "100%": {
                                                    transform: "scale(2.4)",
                                                    opacity: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                backgroundColor: "primary.main",
                                                width: 50,
                                                height: 50,
                                            }}
                                            alt={user?.namaLengkap}
                                            src={
                                                user?.gambar ??
                                                user?.namaLengkap
                                            }
                                        />
                                    </Badge>
                                ) : (
                                    <Avatar
                                        sx={{
                                            backgroundColor: "primary.main",
                                            width: 50,
                                            height: 50,
                                        }}
                                        alt={user?.namaLengkap}
                                        src={user?.gambar ?? user?.namaLengkap}
                                    />
                                )}
                            </Badge>
                            <Box>
                                <Typography
                                    variant="subtitle2"
                                    fontWeight="bold"
                                    textAlign="center"
                                >
                                    {user?.namaLengkap}
                                </Typography>
                                <Stack spacing={1} alignItems="center">
                                    <Typography
                                        textAlign="center"
                                        variant="caption"
                                        component="div"
                                    >
                                        {isLoadingWarehouse || isLoadingUser ? (
                                            <CircularProgress
                                                size={20}
                                                sx={{ mt: 2 }}
                                            />
                                        ) : (
                                            warehouseData?.nama
                                        )}
                                    </Typography>
                                    {isLoadingWarehouse ||
                                    isLoadingUser ? null : (
                                        <Chip
                                            label={"PRO"}
                                            size="small"
                                            sx={{
                                                backgroundColor: "#45A779",
                                                color: "#fff",
                                            }}
                                        />
                                    )}
                                </Stack>
                            </Box>
                        </Stack>
                    </Link>
                </Box>
                <Stack direction="column" spacing="13px" alignItems="center">
                    {user?.aksesTransaksi === 1 && (
                        <ListItem
                            button
                            component={Link}
                            to="/transaksi"
                            selected={location.pathname === "/transaksi"}
                            sx={{
                                width: 80,
                                height: 80,
                                padding: 0,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 1,
                            }}
                        >
                            <Stack
                                direction="column"
                                spacing="10px"
                                alignItems="center"
                            >
                                <ShoppingCartIcon
                                    sx={{ fontSize: "24px", color: "#363845" }}
                                />
                                <Typography fontSize="12px" color="#363845">
                                    Penjualan
                                </Typography>
                            </Stack>
                        </ListItem>
                    )}
                    {user?.aksesStok === 1 && (
                        <ListItem
                            button
                            component={Link}
                            to="/stok"
                            selected={location.pathname === "/stok"}
                            sx={{
                                width: 80,
                                height: 80,
                                padding: 0,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 1,
                            }}
                        >
                            <Stack
                                direction="column"
                                spacing="10px"
                                alignItems="center"
                            >
                                <AllInboxIcon
                                    sx={{ fontSize: "24px", color: "#363845" }}
                                />
                                <Typography fontSize="12px" color="#363845">
                                    Stok
                                </Typography>
                            </Stack>
                        </ListItem>
                    )}
                    {user?.aksesLaporan === 1 && (
                        <ListItem
                            button
                            component={Link}
                            to="/laporan"
                            selected={location.pathname === "/laporan"}
                            sx={{
                                width: 80,
                                height: 80,
                                padding: 0,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 1,
                            }}
                        >
                            <Stack
                                direction="column"
                                spacing="10px"
                                alignItems="center"
                            >
                                <StackedBarChartIcon
                                    sx={{ fontSize: "24px", color: "#363845" }}
                                />
                                <Typography fontSize="12px" color="#363845">
                                    Laporan
                                </Typography>
                            </Stack>
                        </ListItem>
                    )}
                </Stack>
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                flexGrow={1}
            />
            <Box padding={2}>
                <Button
                    href={`https://wa.me/send?phone=${noWaAdmin?.nomor}&text=Saya%20ingin%20bertanya%20mengenai%20Puffhaven%20Kasir%20saya.`}
                    target="_blank"
                    rel="noreferrer"
                    variant="outlined"
                    startIcon={<WhatsApp />}
                    color="whatsapp"
                    sx={{ textTransform: "none" }}
                >
                    Hubungi Kami
                </Button>
            </Box>
            <Box
                width="100%"
                display="flex"
                flexDirection="column"
                paddingX={2}
            >
                <Typography fontSize="12px" color="#999999">
                    Powered by
                </Typography>
                <MaterialLink
                    target="_blank"
                    href="https://nore.web.id/"
                    underline="hover"
                    display="inline"
                    color="#999999"
                >
                    <Typography
                        fontSize="15px"
                        color="#999999"
                        fontWeight="bold"
                    >
                        {`Nore Inovasi © ${thisYear}`}
                    </Typography>
                </MaterialLink>
            </Box>
        </Stack>
    );

    const container =
        window !== undefined ? () => window.document.body : undefined;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const queryWarehouseId = urlParams.get("redirect");

    // if (isLoadingWarehouse || isLoadingUser) {
    //     return (
    //         <Box position="relative" height="100vh">
    //             <Spinner />
    //         </Box>
    //     );
    // }

    return (
        <Box
            sx={{
                display: !!queryWarehouseId ? "none" : "flex",
                paddingTop: isPhoneScreen
                    ? "56px"
                    : isLaptopScreen
                    ? undefined
                    : "64px",
            }}
        >
            <AppBar
                sx={{
                    display: { xs: "block", lg: "none" },
                    width: { lg: `calc(100% - 190px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { lg: "none" } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        {warehouseData?.nama}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { lg: 190 }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: "block", lg: "block" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                        },
                    }}
                >
                    {laptopDrawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: {
                            xs: "none",
                            sm: "none",
                            md: "none",
                            lg: "block",
                        },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: 190,
                        },
                    }}
                    open
                >
                    {laptopDrawer}
                </Drawer>
            </Box>
            <Box component="main" sx={{ flexGrow: 1 }}>
                <AlertSnackbar
                    open={isOpenAlert}
                    onClose={handleCloseAlert}
                    words={words}
                />
                <ModalKonfirmasiLogout />
                {warehouseData &&
                    warehouseIsDueExpired &&
                    warehouseIsDueExpired.totalElements > 0 &&
                    warehouseIsDueExpired.content
                        .filter((list) => list.id === warehouseData.id)
                        .map((item, idx) => {
                            return (
                                <Box
                                    key={item.id}
                                    display="flex"
                                    justifyContent="center"
                                    padding={1}
                                    sx={{
                                        bgcolor: "rgba(229, 40, 40, 0.1)",
                                        border: "1px solid rgba(229, 40, 40, 1)",
                                        // height: "48.75px",
                                    }}
                                >
                                    {/* {moment(time?.datetime).isAfter(
                                        item.pembayaranBerikutnya,
                                    ) ? (
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Typography
                                                component="div"
                                                color="#6D6D6D"
                                                variant="body2"
                                            >
                                                Langganan <b>{item.namaToko}</b>{" "}
                                                sudah lewat jatuh tempo{" "}
                                                <Box
                                                    display="inline"
                                                    fontWeight="bold"
                                                    color="#E52828"
                                                >
                                                    {item.pembayaranBerikutnya ===
                                                    null
                                                        ? ""
                                                        : new Date(
                                                              item?.pembayaranBerikutnya,
                                                          ).toLocaleString(
                                                              "id",
                                                              {
                                                                  day: "numeric",
                                                                  month: "long",
                                                                  year: "numeric",
                                                              },
                                                          )}
                                                </Box>
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="buttonred"
                                                disableElevation
                                                onClick={() =>
                                                    setIsOpenModalAlertPro(true)
                                                }
                                                sx={{
                                                    minWidth: 130,
                                                    maxWidth: 130,
                                                }}
                                            >
                                                Upgrade ke PRO
                                            </Button>
                                        </Stack>
                                    ) : (
                                        <Typography color="rgba(229, 40, 40, 1)">
                                            Langganan <b>{item.namaToko}</b>{" "}
                                            mendekati jatuh tempo! Segera
                                            perbarui sebelum tanggal{" "}
                                            <b>
                                                {item.pembayaranBerikutnya ===
                                                null
                                                    ? ""
                                                    : new Date(
                                                          item?.pembayaranBerikutnya,
                                                      ).toLocaleString("id", {
                                                          day: "numeric",
                                                          month: "long",
                                                          year: "numeric",
                                                      })}
                                            </b>
                                            .
                                        </Typography>
                                    )} */}
                                </Box>
                            );
                        })}
                {/* {warehouseData &&
                    warehouseData.isTrial !== 1 &&
                    warehouseData?.isPro !== 1 && (
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="center"
                            padding={1}
                            sx={{
                                bgcolor: "rgba(69, 167, 121, 0.1)",
                                border: "1px solid rgba(69, 167, 121, 1)",
                                // height: "48.75px",
                            }}
                        >
                            <Typography color="rgba(69, 167, 121, 1)">
                                Uji coba gratis selama 7 hari untuk mencoba
                                fitur-fitur PRO UKM Lokal
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                color="buttonulo"
                                disableElevation
                                onClick={openModalTrial}
                                sx={{ minWidth: 100, maxWidth: 100 }}
                            >
                                Free Trial
                            </Button>
                        </Stack>
                    )}
                {warehouseData &&
                    warehouseData.isTrial === 1 &&
                    warehouseData?.isPro === 1 &&
                    warehouseData.trialTempo && (
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent="center"
                            padding={1}
                            sx={{
                                bgcolor: "rgba(69, 167, 121, 0.1)",
                                border: "1px solid rgba(69, 167, 121, 1)",
                                // height: "48.75px",
                            }}
                        >
                            <Typography
                                component="div"
                                color="rgba(69, 167, 121, 1)"
                            >
                                Waktu trial anda akan habis dalam:{" "}
                                <CountdownComponent expiredTime={expiredTime} />
                                <Typography
                                    display="inline"
                                    color="rgba(69, 167, 121, 1)"
                                >
                                    {" "}
                                    (sampai{" "}
                                    {moment(warehouseData.trialTempo).format(
                                        "LL",
                                    )}
                                    )
                                </Typography>
                            </Typography>
                        </Stack>
                    )}
                {warehouseData &&
                    warehouseData.isTrial === 1 &&
                    warehouseData?.isPro !== 1 && (
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="center"
                            padding={1}
                            sx={{
                                bgcolor: "rgba(69, 167, 121, 0.1)",
                                border: "1px solid rgba(69, 167, 121, 1)",
                                // height: "48.75px",
                            }}
                        >
                            <Typography color="rgba(69, 167, 121, 1)">
                                Waktu trial anda sudah habis! Segera upgrade
                                untuk mendapatkan fitur-fitur PRO kembali!
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                color="buttonulo"
                                disableElevation
                                onClick={() => setIsOpenModalAlertPro(true)}
                                sx={{ minWidth: 130, maxWidth: 130 }}
                            >
                                Upgrade ke PRO
                            </Button>
                        </Stack>
                    )} */}
                <Backdrop
                    sx={{
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isLoadingUser || isLoadingWarehouse}
                >
                    <img
                        src={logoUloGif}
                        height="100px"
                        width="100px"
                        style={{ objectFit: "contain" }}
                        alt="loading..."
                    />
                    <Typography color="#fff">
                        Memuat Data Warehouse...
                    </Typography>
                </Backdrop>
                <Container maxWidth="xl">{children}</Container>
            </Box>
            {/* {warehouseData && (
                <ModalTrial
                    closeModalTrial={closeModalTrial}
                    isOpenModalTrial={isOpenModalTrial}
                    warehouseData={warehouseData}
                />
            )} */}
            {warehouseData && (
                <ModalAlertPro
                    isOpenModalAlertPro={isOpenModalAlertPro}
                    closeModalAlertPro={() => setIsOpenModalAlertPro(false)}
                    dataWarehouse={{
                        id: Number(warehouseData?.id),
                        nama: warehouseData?.nama,
                    }}
                />
            )}
        </Box>
    );
}
